function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 84 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: ".5",
  width: "82",
  height: "28",
  rx: "1.5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "5.5",
  y: "5",
  width: "21",
  height: "19",
  rx: "2",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30.5",
  y: "5",
  width: "20",
  height: "4",
  rx: "2",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30.5",
  y: "11",
  width: "39",
  height: "2",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30.5",
  y: "15",
  width: "39",
  height: "2",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "31.5",
  y: "20",
  width: "19",
  height: "4",
  rx: "1",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: ".5",
  width: "82",
  height: "28",
  rx: "1.5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.05 3.346a.346.346 0 01.49.49l-2.204 2.203a.346.346 0 01-.49-.49l2.204-2.203z",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.54 5.55a.346.346 0 01-.49.49l-2.203-2.203a.346.346 0 11.49-.49l2.202 2.203z",
  fill: "#DDE0E4"
})));